import { indexedDiscounts, indexedDiscountsMarca } from "./indexedDiscounts";

const tooltips = {
    indexedDiscounts,
    indexedDiscountsMarca
}

export default tooltips;
